import { FC } from 'react';
import { Avatar, AvatarProps } from 'antd';
import cn from 'classnames';

import styles from './index.module.scss';

export const CandidateProfileAvatar: FC<AvatarProps> = ({ className, size, ...props }) => {
	return <Avatar className={cn(styles.avatar, className)} shape="circle" size={size || 60} {...props} />;
};
